import { render, staticRenderFns } from "./eventtagsTax.vue?vue&type=template&id=e3cb6446"
import script from "./eventtagsTax.vue?vue&type=script&lang=js"
export * from "./eventtagsTax.vue?vue&type=script&lang=js"
import style0 from "./eventtagsTax.vue?vue&type=style&index=0&id=e3cb6446&prod&lang=css"
import style1 from "./eventtagsTax.vue?vue&type=style&index=1&id=e3cb6446&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports